(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $f731e8acd6e365c2$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $f731e8acd6e365c2$var$hasPassiveEvents = false;
if (typeof window !== "undefined") {
    var $f731e8acd6e365c2$var$passiveTestOptions = {
        get passive () {
            $f731e8acd6e365c2$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener("testPassive", null, $f731e8acd6e365c2$var$passiveTestOptions);
    window.removeEventListener("testPassive", null, $f731e8acd6e365c2$var$passiveTestOptions);
}
var $f731e8acd6e365c2$var$isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
var $f731e8acd6e365c2$var$locks = [];
var $f731e8acd6e365c2$var$documentListenerAdded = false;
var $f731e8acd6e365c2$var$initialClientY = -1;
var $f731e8acd6e365c2$var$previousBodyOverflowSetting = void 0;
var $f731e8acd6e365c2$var$previousBodyPosition = void 0;
var $f731e8acd6e365c2$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $f731e8acd6e365c2$var$allowTouchMove = function allowTouchMove(el) {
    return $f731e8acd6e365c2$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $f731e8acd6e365c2$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($f731e8acd6e365c2$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $f731e8acd6e365c2$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($f731e8acd6e365c2$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
            $f731e8acd6e365c2$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + "px";
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($f731e8acd6e365c2$var$previousBodyOverflowSetting === undefined) {
        $f731e8acd6e365c2$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = "hidden";
    }
};
var $f731e8acd6e365c2$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($f731e8acd6e365c2$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $f731e8acd6e365c2$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $f731e8acd6e365c2$var$previousBodyPaddingRight = undefined;
    }
    if ($f731e8acd6e365c2$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $f731e8acd6e365c2$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $f731e8acd6e365c2$var$previousBodyOverflowSetting = undefined;
    }
};
var $f731e8acd6e365c2$var$setPositionFixed = function setPositionFixed() {
    return window.requestAnimationFrame(function() {
        // If previousBodyPosition is already set, don't set it again.
        if ($f731e8acd6e365c2$var$previousBodyPosition === undefined) {
            $f731e8acd6e365c2$var$previousBodyPosition = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left
            };
            // Update the dom inside an animation frame 
            var _window = window, scrollY = _window.scrollY, scrollX = _window.scrollX, innerHeight = _window.innerHeight;
            document.body.style.position = "fixed";
            document.body.style.top = -scrollY;
            document.body.style.left = -scrollX;
            setTimeout(function() {
                return window.requestAnimationFrame(function() {
                    // Attempt to check if the bottom bar appeared due to the position change
                    var bottomBarHeight = innerHeight - window.innerHeight;
                    if (bottomBarHeight && scrollY >= innerHeight) // Move the content further up so that the bottom bar doesn't hide it
                    document.body.style.top = -(scrollY + bottomBarHeight);
                });
            }, 300);
        }
    });
};
var $f731e8acd6e365c2$var$restorePositionSetting = function restorePositionSetting() {
    if ($f731e8acd6e365c2$var$previousBodyPosition !== undefined) {
        // Convert the position from "px" to Int
        var y = -parseInt(document.body.style.top, 10);
        var x = -parseInt(document.body.style.left, 10);
        // Restore styles
        document.body.style.position = $f731e8acd6e365c2$var$previousBodyPosition.position;
        document.body.style.top = $f731e8acd6e365c2$var$previousBodyPosition.top;
        document.body.style.left = $f731e8acd6e365c2$var$previousBodyPosition.left;
        // Restore scroll
        window.scrollTo(x, y);
        $f731e8acd6e365c2$var$previousBodyPosition = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $f731e8acd6e365c2$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $f731e8acd6e365c2$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $f731e8acd6e365c2$var$initialClientY;
    if ($f731e8acd6e365c2$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $f731e8acd6e365c2$var$preventDefault(event);
    if ($f731e8acd6e365c2$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $f731e8acd6e365c2$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $f731e8acd6e365c2$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($f731e8acd6e365c2$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $f731e8acd6e365c2$var$locks = [].concat($f731e8acd6e365c2$var$_toConsumableArray($f731e8acd6e365c2$var$locks), [
        lock
    ]);
    if ($f731e8acd6e365c2$var$isIosDevice) $f731e8acd6e365c2$var$setPositionFixed();
    else $f731e8acd6e365c2$var$setOverflowHidden(options);
    if ($f731e8acd6e365c2$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $f731e8acd6e365c2$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $f731e8acd6e365c2$var$handleScroll(event, targetElement);
        };
        if (!$f731e8acd6e365c2$var$documentListenerAdded) {
            document.addEventListener("touchmove", $f731e8acd6e365c2$var$preventDefault, $f731e8acd6e365c2$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $f731e8acd6e365c2$var$documentListenerAdded = true;
        }
    }
};
var $f731e8acd6e365c2$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($f731e8acd6e365c2$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $f731e8acd6e365c2$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($f731e8acd6e365c2$var$documentListenerAdded) {
            document.removeEventListener("touchmove", $f731e8acd6e365c2$var$preventDefault, $f731e8acd6e365c2$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $f731e8acd6e365c2$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $f731e8acd6e365c2$var$initialClientY = -1;
    }
    if ($f731e8acd6e365c2$var$isIosDevice) $f731e8acd6e365c2$var$restorePositionSetting();
    else $f731e8acd6e365c2$var$restoreOverflowSetting();
    $f731e8acd6e365c2$var$locks = [];
};
var $f731e8acd6e365c2$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
        return;
    }
    $f731e8acd6e365c2$var$locks = $f731e8acd6e365c2$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($f731e8acd6e365c2$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($f731e8acd6e365c2$var$documentListenerAdded && $f731e8acd6e365c2$var$locks.length === 0) {
            document.removeEventListener("touchmove", $f731e8acd6e365c2$var$preventDefault, $f731e8acd6e365c2$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $f731e8acd6e365c2$var$documentListenerAdded = false;
        }
    }
    if ($f731e8acd6e365c2$var$isIosDevice) $f731e8acd6e365c2$var$restorePositionSetting();
    else $f731e8acd6e365c2$var$restoreOverflowSetting();
};


/*
 * anime.js v3.2.2
 * (c) 2023 Julian Garnier
 * Released under the MIT license
 * animejs.com
 */ // Defaults
var $84e77bd4943abbdb$var$defaultInstanceSettings = {
    update: null,
    begin: null,
    loopBegin: null,
    changeBegin: null,
    change: null,
    changeComplete: null,
    loopComplete: null,
    complete: null,
    loop: 1,
    direction: "normal",
    autoplay: true,
    timelineOffset: 0
};
var $84e77bd4943abbdb$var$defaultTweenSettings = {
    duration: 1000,
    delay: 0,
    endDelay: 0,
    easing: "easeOutElastic(1, .5)",
    round: 0
};
var $84e77bd4943abbdb$var$validTransforms = [
    "translateX",
    "translateY",
    "translateZ",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "scale",
    "scaleX",
    "scaleY",
    "scaleZ",
    "skew",
    "skewX",
    "skewY",
    "perspective",
    "matrix",
    "matrix3d"
];
// Caching
var $84e77bd4943abbdb$var$cache = {
    CSS: {},
    springs: {}
};
// Utils
function $84e77bd4943abbdb$var$minMax(val, min, max) {
    return Math.min(Math.max(val, min), max);
}
function $84e77bd4943abbdb$var$stringContains(str, text) {
    return str.indexOf(text) > -1;
}
function $84e77bd4943abbdb$var$applyArguments(func, args) {
    return func.apply(null, args);
}
var $84e77bd4943abbdb$var$is = {
    arr: function(a) {
        return Array.isArray(a);
    },
    obj: function(a) {
        return $84e77bd4943abbdb$var$stringContains(Object.prototype.toString.call(a), "Object");
    },
    pth: function(a) {
        return $84e77bd4943abbdb$var$is.obj(a) && a.hasOwnProperty("totalLength");
    },
    svg: function(a) {
        return a instanceof SVGElement;
    },
    inp: function(a) {
        return a instanceof HTMLInputElement;
    },
    dom: function(a) {
        return a.nodeType || $84e77bd4943abbdb$var$is.svg(a);
    },
    str: function(a) {
        return typeof a === "string";
    },
    fnc: function(a) {
        return typeof a === "function";
    },
    und: function(a) {
        return typeof a === "undefined";
    },
    nil: function(a) {
        return $84e77bd4943abbdb$var$is.und(a) || a === null;
    },
    hex: function(a) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a);
    },
    rgb: function(a) {
        return /^rgb/.test(a);
    },
    hsl: function(a) {
        return /^hsl/.test(a);
    },
    col: function(a) {
        return $84e77bd4943abbdb$var$is.hex(a) || $84e77bd4943abbdb$var$is.rgb(a) || $84e77bd4943abbdb$var$is.hsl(a);
    },
    key: function(a) {
        return !$84e77bd4943abbdb$var$defaultInstanceSettings.hasOwnProperty(a) && !$84e77bd4943abbdb$var$defaultTweenSettings.hasOwnProperty(a) && a !== "targets" && a !== "keyframes";
    }
};
// Easings
function $84e77bd4943abbdb$var$parseEasingParameters(string) {
    var match = /\(([^)]+)\)/.exec(string);
    return match ? match[1].split(",").map(function(p) {
        return parseFloat(p);
    }) : [];
}
// Spring solver inspired by Webkit Copyright © 2016 Apple Inc. All rights reserved. https://webkit.org/demos/spring/spring.js
function $84e77bd4943abbdb$var$spring(string, duration) {
    var params = $84e77bd4943abbdb$var$parseEasingParameters(string);
    var mass = $84e77bd4943abbdb$var$minMax($84e77bd4943abbdb$var$is.und(params[0]) ? 1 : params[0], .1, 100);
    var stiffness = $84e77bd4943abbdb$var$minMax($84e77bd4943abbdb$var$is.und(params[1]) ? 100 : params[1], .1, 100);
    var damping = $84e77bd4943abbdb$var$minMax($84e77bd4943abbdb$var$is.und(params[2]) ? 10 : params[2], .1, 100);
    var velocity = $84e77bd4943abbdb$var$minMax($84e77bd4943abbdb$var$is.und(params[3]) ? 0 : params[3], .1, 100);
    var w0 = Math.sqrt(stiffness / mass);
    var zeta = damping / (2 * Math.sqrt(stiffness * mass));
    var wd = zeta < 1 ? w0 * Math.sqrt(1 - zeta * zeta) : 0;
    var a = 1;
    var b = zeta < 1 ? (zeta * w0 + -velocity) / wd : -velocity + w0;
    function solver(t) {
        var progress = duration ? duration * t / 1000 : t;
        if (zeta < 1) progress = Math.exp(-progress * zeta * w0) * (a * Math.cos(wd * progress) + b * Math.sin(wd * progress));
        else progress = (a + b * progress) * Math.exp(-progress * w0);
        if (t === 0 || t === 1) return t;
        return 1 - progress;
    }
    function getDuration() {
        var cached = $84e77bd4943abbdb$var$cache.springs[string];
        if (cached) return cached;
        var frame = 1 / 6;
        var elapsed = 0;
        var rest = 0;
        while(true){
            elapsed += frame;
            if (solver(elapsed) === 1) {
                rest++;
                if (rest >= 16) break;
            } else rest = 0;
        }
        var duration = elapsed * frame * 1000;
        $84e77bd4943abbdb$var$cache.springs[string] = duration;
        return duration;
    }
    return duration ? solver : getDuration;
}
// Basic steps easing implementation https://developer.mozilla.org/fr/docs/Web/CSS/transition-timing-function
function $84e77bd4943abbdb$var$steps(steps) {
    if (steps === void 0) steps = 10;
    return function(t) {
        return Math.ceil($84e77bd4943abbdb$var$minMax(t, 0.000001, 1) * steps) * (1 / steps);
    };
}
// BezierEasing https://github.com/gre/bezier-easing
var $84e77bd4943abbdb$var$bezier = function() {
    var kSplineTableSize = 11;
    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
    function A(aA1, aA2) {
        return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }
    function B(aA1, aA2) {
        return 3.0 * aA2 - 6.0 * aA1;
    }
    function C(aA1) {
        return 3.0 * aA1;
    }
    function calcBezier(aT, aA1, aA2) {
        return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }
    function getSlope(aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }
    function binarySubdivide(aX, aA, aB, mX1, mX2) {
        var currentX, currentT, i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) aB = currentT;
            else aA = currentT;
        }while (Math.abs(currentX) > 0.0000001 && ++i < 10);
        return currentT;
    }
    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
        for(var i = 0; i < 4; ++i){
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) return aGuessT;
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }
    function bezier(mX1, mY1, mX2, mY2) {
        if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) return;
        var sampleValues = new Float32Array(kSplineTableSize);
        if (mX1 !== mY1 || mX2 !== mY2) for(var i = 0; i < kSplineTableSize; ++i)sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
        function getTForX(aX) {
            var intervalStart = 0;
            var currentSample = 1;
            var lastSample = kSplineTableSize - 1;
            for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
            --currentSample;
            var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
            var guessForT = intervalStart + dist * kSampleStepSize;
            var initialSlope = getSlope(guessForT, mX1, mX2);
            if (initialSlope >= 0.001) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
            else if (initialSlope === 0.0) return guessForT;
            else return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
        }
        return function(x) {
            if (mX1 === mY1 && mX2 === mY2) return x;
            if (x === 0 || x === 1) return x;
            return calcBezier(getTForX(x), mY1, mY2);
        };
    }
    return bezier;
}();
var $84e77bd4943abbdb$var$penner = function() {
    // Based on jQuery UI's implemenation of easing equations from Robert Penner (http://www.robertpenner.com/easing)
    var eases = {
        linear: function() {
            return function(t) {
                return t;
            };
        }
    };
    var functionEasings = {
        Sine: function() {
            return function(t) {
                return 1 - Math.cos(t * Math.PI / 2);
            };
        },
        Expo: function() {
            return function(t) {
                return t ? Math.pow(2, 10 * t - 10) : 0;
            };
        },
        Circ: function() {
            return function(t) {
                return 1 - Math.sqrt(1 - t * t);
            };
        },
        Back: function() {
            return function(t) {
                return t * t * (3 * t - 2);
            };
        },
        Bounce: function() {
            return function(t) {
                var pow2, b = 4;
                while(t < ((pow2 = Math.pow(2, --b)) - 1) / 11);
                return 1 / Math.pow(4, 3 - b) - 7.5625 * Math.pow((pow2 * 3 - 2) / 22 - t, 2);
            };
        },
        Elastic: function(amplitude, period) {
            if (amplitude === void 0) amplitude = 1;
            if (period === void 0) period = .5;
            var a = $84e77bd4943abbdb$var$minMax(amplitude, 1, 10);
            var p = $84e77bd4943abbdb$var$minMax(period, .1, 2);
            return function(t) {
                return t === 0 || t === 1 ? t : -a * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1 - p / (Math.PI * 2) * Math.asin(1 / a)) * (Math.PI * 2) / p);
            };
        }
    };
    var baseEasings = [
        "Quad",
        "Cubic",
        "Quart",
        "Quint"
    ];
    baseEasings.forEach(function(name, i) {
        functionEasings[name] = function() {
            return function(t) {
                return Math.pow(t, i + 2);
            };
        };
    });
    Object.keys(functionEasings).forEach(function(name) {
        var easeIn = functionEasings[name];
        eases["easeIn" + name] = easeIn;
        eases["easeOut" + name] = function(a, b) {
            return function(t) {
                return 1 - easeIn(a, b)(1 - t);
            };
        };
        eases["easeInOut" + name] = function(a, b) {
            return function(t) {
                return t < 0.5 ? easeIn(a, b)(t * 2) / 2 : 1 - easeIn(a, b)(t * -2 + 2) / 2;
            };
        };
        eases["easeOutIn" + name] = function(a, b) {
            return function(t) {
                return t < 0.5 ? (1 - easeIn(a, b)(1 - t * 2)) / 2 : (easeIn(a, b)(t * 2 - 1) + 1) / 2;
            };
        };
    });
    return eases;
}();
function $84e77bd4943abbdb$var$parseEasings(easing, duration) {
    if ($84e77bd4943abbdb$var$is.fnc(easing)) return easing;
    var name = easing.split("(")[0];
    var ease = $84e77bd4943abbdb$var$penner[name];
    var args = $84e77bd4943abbdb$var$parseEasingParameters(easing);
    switch(name){
        case "spring":
            return $84e77bd4943abbdb$var$spring(easing, duration);
        case "cubicBezier":
            return $84e77bd4943abbdb$var$applyArguments($84e77bd4943abbdb$var$bezier, args);
        case "steps":
            return $84e77bd4943abbdb$var$applyArguments($84e77bd4943abbdb$var$steps, args);
        default:
            return $84e77bd4943abbdb$var$applyArguments(ease, args);
    }
}
// Strings
function $84e77bd4943abbdb$var$selectString(str) {
    try {
        var nodes = document.querySelectorAll(str);
        return nodes;
    } catch (e) {
        return;
    }
}
// Arrays
function $84e77bd4943abbdb$var$filterArray(arr, callback) {
    var len = arr.length;
    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    var result = [];
    for(var i = 0; i < len; i++)if (i in arr) {
        var val = arr[i];
        if (callback.call(thisArg, val, i, arr)) result.push(val);
    }
    return result;
}
function $84e77bd4943abbdb$var$flattenArray(arr) {
    return arr.reduce(function(a, b) {
        return a.concat($84e77bd4943abbdb$var$is.arr(b) ? $84e77bd4943abbdb$var$flattenArray(b) : b);
    }, []);
}
function $84e77bd4943abbdb$var$toArray(o) {
    if ($84e77bd4943abbdb$var$is.arr(o)) return o;
    if ($84e77bd4943abbdb$var$is.str(o)) o = $84e77bd4943abbdb$var$selectString(o) || o;
    if (o instanceof NodeList || o instanceof HTMLCollection) return [].slice.call(o);
    return [
        o
    ];
}
function $84e77bd4943abbdb$var$arrayContains(arr, val) {
    return arr.some(function(a) {
        return a === val;
    });
}
// Objects
function $84e77bd4943abbdb$var$cloneObject(o) {
    var clone = {};
    for(var p in o)clone[p] = o[p];
    return clone;
}
function $84e77bd4943abbdb$var$replaceObjectProps(o1, o2) {
    var o = $84e77bd4943abbdb$var$cloneObject(o1);
    for(var p in o1)o[p] = o2.hasOwnProperty(p) ? o2[p] : o1[p];
    return o;
}
function $84e77bd4943abbdb$var$mergeObjects(o1, o2) {
    var o = $84e77bd4943abbdb$var$cloneObject(o1);
    for(var p in o2)o[p] = $84e77bd4943abbdb$var$is.und(o1[p]) ? o2[p] : o1[p];
    return o;
}
// Colors
function $84e77bd4943abbdb$var$rgbToRgba(rgbValue) {
    var rgb = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(rgbValue);
    return rgb ? "rgba(" + rgb[1] + ",1)" : rgbValue;
}
function $84e77bd4943abbdb$var$hexToRgba(hexValue) {
    var rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    var hex = hexValue.replace(rgx, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    var r = parseInt(rgb[1], 16);
    var g = parseInt(rgb[2], 16);
    var b = parseInt(rgb[3], 16);
    return "rgba(" + r + "," + g + "," + b + ",1)";
}
function $84e77bd4943abbdb$var$hslToRgba(hslValue) {
    var hsl = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(hslValue) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(hslValue);
    var h = parseInt(hsl[1], 10) / 360;
    var s = parseInt(hsl[2], 10) / 100;
    var l = parseInt(hsl[3], 10) / 100;
    var a = hsl[4] || 1;
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    var r, g, b;
    if (s == 0) r = g = b = l;
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return "rgba(" + r * 255 + "," + g * 255 + "," + b * 255 + "," + a + ")";
}
function $84e77bd4943abbdb$var$colorToRgb(val) {
    if ($84e77bd4943abbdb$var$is.rgb(val)) return $84e77bd4943abbdb$var$rgbToRgba(val);
    if ($84e77bd4943abbdb$var$is.hex(val)) return $84e77bd4943abbdb$var$hexToRgba(val);
    if ($84e77bd4943abbdb$var$is.hsl(val)) return $84e77bd4943abbdb$var$hslToRgba(val);
}
// Units
function $84e77bd4943abbdb$var$getUnit(val) {
    var split = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(val);
    if (split) return split[1];
}
function $84e77bd4943abbdb$var$getTransformUnit(propName) {
    if ($84e77bd4943abbdb$var$stringContains(propName, "translate") || propName === "perspective") return "px";
    if ($84e77bd4943abbdb$var$stringContains(propName, "rotate") || $84e77bd4943abbdb$var$stringContains(propName, "skew")) return "deg";
}
// Values
function $84e77bd4943abbdb$var$getFunctionValue(val, animatable) {
    if (!$84e77bd4943abbdb$var$is.fnc(val)) return val;
    return val(animatable.target, animatable.id, animatable.total);
}
function $84e77bd4943abbdb$var$getAttribute(el, prop) {
    return el.getAttribute(prop);
}
function $84e77bd4943abbdb$var$convertPxToUnit(el, value, unit) {
    var valueUnit = $84e77bd4943abbdb$var$getUnit(value);
    if ($84e77bd4943abbdb$var$arrayContains([
        unit,
        "deg",
        "rad",
        "turn"
    ], valueUnit)) return value;
    var cached = $84e77bd4943abbdb$var$cache.CSS[value + unit];
    if (!$84e77bd4943abbdb$var$is.und(cached)) return cached;
    var baseline = 100;
    var tempEl = document.createElement(el.tagName);
    var parentEl = el.parentNode && el.parentNode !== document ? el.parentNode : document.body;
    parentEl.appendChild(tempEl);
    tempEl.style.position = "absolute";
    tempEl.style.width = baseline + unit;
    var factor = baseline / tempEl.offsetWidth;
    parentEl.removeChild(tempEl);
    var convertedUnit = factor * parseFloat(value);
    $84e77bd4943abbdb$var$cache.CSS[value + unit] = convertedUnit;
    return convertedUnit;
}
function $84e77bd4943abbdb$var$getCSSValue(el, prop, unit) {
    if (prop in el.style) {
        var uppercasePropName = prop.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        var value = el.style[prop] || getComputedStyle(el).getPropertyValue(uppercasePropName) || "0";
        return unit ? $84e77bd4943abbdb$var$convertPxToUnit(el, value, unit) : value;
    }
}
function $84e77bd4943abbdb$var$getAnimationType(el, prop) {
    if ($84e77bd4943abbdb$var$is.dom(el) && !$84e77bd4943abbdb$var$is.inp(el) && (!$84e77bd4943abbdb$var$is.nil($84e77bd4943abbdb$var$getAttribute(el, prop)) || $84e77bd4943abbdb$var$is.svg(el) && el[prop])) return "attribute";
    if ($84e77bd4943abbdb$var$is.dom(el) && $84e77bd4943abbdb$var$arrayContains($84e77bd4943abbdb$var$validTransforms, prop)) return "transform";
    if ($84e77bd4943abbdb$var$is.dom(el) && prop !== "transform" && $84e77bd4943abbdb$var$getCSSValue(el, prop)) return "css";
    if (el[prop] != null) return "object";
}
function $84e77bd4943abbdb$var$getElementTransforms(el) {
    if (!$84e77bd4943abbdb$var$is.dom(el)) return;
    var str = el.style.transform || "";
    var reg = /(\w+)\(([^)]*)\)/g;
    var transforms = new Map();
    var m;
    while(m = reg.exec(str))transforms.set(m[1], m[2]);
    return transforms;
}
function $84e77bd4943abbdb$var$getTransformValue(el, propName, animatable, unit) {
    var defaultVal = $84e77bd4943abbdb$var$stringContains(propName, "scale") ? 1 : 0 + $84e77bd4943abbdb$var$getTransformUnit(propName);
    var value = $84e77bd4943abbdb$var$getElementTransforms(el).get(propName) || defaultVal;
    if (animatable) {
        animatable.transforms.list.set(propName, value);
        animatable.transforms["last"] = propName;
    }
    return unit ? $84e77bd4943abbdb$var$convertPxToUnit(el, value, unit) : value;
}
function $84e77bd4943abbdb$var$getOriginalTargetValue(target, propName, unit, animatable) {
    switch($84e77bd4943abbdb$var$getAnimationType(target, propName)){
        case "transform":
            return $84e77bd4943abbdb$var$getTransformValue(target, propName, animatable, unit);
        case "css":
            return $84e77bd4943abbdb$var$getCSSValue(target, propName, unit);
        case "attribute":
            return $84e77bd4943abbdb$var$getAttribute(target, propName);
        default:
            return target[propName] || 0;
    }
}
function $84e77bd4943abbdb$var$getRelativeValue(to, from) {
    var operator = /^(\*=|\+=|-=)/.exec(to);
    if (!operator) return to;
    var u = $84e77bd4943abbdb$var$getUnit(to) || 0;
    var x = parseFloat(from);
    var y = parseFloat(to.replace(operator[0], ""));
    switch(operator[0][0]){
        case "+":
            return x + y + u;
        case "-":
            return x - y + u;
        case "*":
            return x * y + u;
    }
}
function $84e77bd4943abbdb$var$validateValue(val, unit) {
    if ($84e77bd4943abbdb$var$is.col(val)) return $84e77bd4943abbdb$var$colorToRgb(val);
    if (/\s/g.test(val)) return val;
    var originalUnit = $84e77bd4943abbdb$var$getUnit(val);
    var unitLess = originalUnit ? val.substr(0, val.length - originalUnit.length) : val;
    if (unit) return unitLess + unit;
    return unitLess;
}
// getTotalLength() equivalent for circle, rect, polyline, polygon and line shapes
// adapted from https://gist.github.com/SebLambla/3e0550c496c236709744
function $84e77bd4943abbdb$var$getDistance(p1, p2) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}
function $84e77bd4943abbdb$var$getCircleLength(el) {
    return Math.PI * 2 * $84e77bd4943abbdb$var$getAttribute(el, "r");
}
function $84e77bd4943abbdb$var$getRectLength(el) {
    return $84e77bd4943abbdb$var$getAttribute(el, "width") * 2 + $84e77bd4943abbdb$var$getAttribute(el, "height") * 2;
}
function $84e77bd4943abbdb$var$getLineLength(el) {
    return $84e77bd4943abbdb$var$getDistance({
        x: $84e77bd4943abbdb$var$getAttribute(el, "x1"),
        y: $84e77bd4943abbdb$var$getAttribute(el, "y1")
    }, {
        x: $84e77bd4943abbdb$var$getAttribute(el, "x2"),
        y: $84e77bd4943abbdb$var$getAttribute(el, "y2")
    });
}
function $84e77bd4943abbdb$var$getPolylineLength(el) {
    var points = el.points;
    var totalLength = 0;
    var previousPos;
    for(var i = 0; i < points.numberOfItems; i++){
        var currentPos = points.getItem(i);
        if (i > 0) totalLength += $84e77bd4943abbdb$var$getDistance(previousPos, currentPos);
        previousPos = currentPos;
    }
    return totalLength;
}
function $84e77bd4943abbdb$var$getPolygonLength(el) {
    var points = el.points;
    return $84e77bd4943abbdb$var$getPolylineLength(el) + $84e77bd4943abbdb$var$getDistance(points.getItem(points.numberOfItems - 1), points.getItem(0));
}
// Path animation
function $84e77bd4943abbdb$var$getTotalLength(el) {
    if (el.getTotalLength) return el.getTotalLength();
    switch(el.tagName.toLowerCase()){
        case "circle":
            return $84e77bd4943abbdb$var$getCircleLength(el);
        case "rect":
            return $84e77bd4943abbdb$var$getRectLength(el);
        case "line":
            return $84e77bd4943abbdb$var$getLineLength(el);
        case "polyline":
            return $84e77bd4943abbdb$var$getPolylineLength(el);
        case "polygon":
            return $84e77bd4943abbdb$var$getPolygonLength(el);
    }
}
function $84e77bd4943abbdb$var$setDashoffset(el) {
    var pathLength = $84e77bd4943abbdb$var$getTotalLength(el);
    el.setAttribute("stroke-dasharray", pathLength);
    return pathLength;
}
// Motion path
function $84e77bd4943abbdb$var$getParentSvgEl(el) {
    var parentEl = el.parentNode;
    while($84e77bd4943abbdb$var$is.svg(parentEl)){
        if (!$84e77bd4943abbdb$var$is.svg(parentEl.parentNode)) break;
        parentEl = parentEl.parentNode;
    }
    return parentEl;
}
function $84e77bd4943abbdb$var$getParentSvg(pathEl, svgData) {
    var svg = svgData || {};
    var parentSvgEl = svg.el || $84e77bd4943abbdb$var$getParentSvgEl(pathEl);
    var rect = parentSvgEl.getBoundingClientRect();
    var viewBoxAttr = $84e77bd4943abbdb$var$getAttribute(parentSvgEl, "viewBox");
    var width = rect.width;
    var height = rect.height;
    var viewBox = svg.viewBox || (viewBoxAttr ? viewBoxAttr.split(" ") : [
        0,
        0,
        width,
        height
    ]);
    return {
        el: parentSvgEl,
        viewBox: viewBox,
        x: viewBox[0] / 1,
        y: viewBox[1] / 1,
        w: width,
        h: height,
        vW: viewBox[2],
        vH: viewBox[3]
    };
}
function $84e77bd4943abbdb$var$getPath(path, percent) {
    var pathEl = $84e77bd4943abbdb$var$is.str(path) ? $84e77bd4943abbdb$var$selectString(path)[0] : path;
    var p = percent || 100;
    return function(property) {
        return {
            property: property,
            el: pathEl,
            svg: $84e77bd4943abbdb$var$getParentSvg(pathEl),
            totalLength: $84e77bd4943abbdb$var$getTotalLength(pathEl) * (p / 100)
        };
    };
}
function $84e77bd4943abbdb$var$getPathProgress(path, progress, isPathTargetInsideSVG) {
    function point(offset) {
        if (offset === void 0) offset = 0;
        var l = progress + offset >= 1 ? progress + offset : 0;
        return path.el.getPointAtLength(l);
    }
    var svg = $84e77bd4943abbdb$var$getParentSvg(path.el, path.svg);
    var p = point();
    var p0 = point(-1);
    var p1 = point(1);
    var scaleX = isPathTargetInsideSVG ? 1 : svg.w / svg.vW;
    var scaleY = isPathTargetInsideSVG ? 1 : svg.h / svg.vH;
    switch(path.property){
        case "x":
            return (p.x - svg.x) * scaleX;
        case "y":
            return (p.y - svg.y) * scaleY;
        case "angle":
            return Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180 / Math.PI;
    }
}
// Decompose value
function $84e77bd4943abbdb$var$decomposeValue(val, unit) {
    // const rgx = /-?\d*\.?\d+/g; // handles basic numbers
    // const rgx = /[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
    var rgx = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
    var value = $84e77bd4943abbdb$var$validateValue($84e77bd4943abbdb$var$is.pth(val) ? val.totalLength : val, unit) + "";
    return {
        original: value,
        numbers: value.match(rgx) ? value.match(rgx).map(Number) : [
            0
        ],
        strings: $84e77bd4943abbdb$var$is.str(val) || unit ? value.split(rgx) : []
    };
}
// Animatables
function $84e77bd4943abbdb$var$parseTargets(targets) {
    var targetsArray = targets ? $84e77bd4943abbdb$var$flattenArray($84e77bd4943abbdb$var$is.arr(targets) ? targets.map($84e77bd4943abbdb$var$toArray) : $84e77bd4943abbdb$var$toArray(targets)) : [];
    return $84e77bd4943abbdb$var$filterArray(targetsArray, function(item, pos, self) {
        return self.indexOf(item) === pos;
    });
}
function $84e77bd4943abbdb$var$getAnimatables(targets) {
    var parsed = $84e77bd4943abbdb$var$parseTargets(targets);
    return parsed.map(function(t, i) {
        return {
            target: t,
            id: i,
            total: parsed.length,
            transforms: {
                list: $84e77bd4943abbdb$var$getElementTransforms(t)
            }
        };
    });
}
// Properties
function $84e77bd4943abbdb$var$normalizePropertyTweens(prop, tweenSettings) {
    var settings = $84e77bd4943abbdb$var$cloneObject(tweenSettings);
    // Override duration if easing is a spring
    if (/^spring/.test(settings.easing)) settings.duration = $84e77bd4943abbdb$var$spring(settings.easing);
    if ($84e77bd4943abbdb$var$is.arr(prop)) {
        var l = prop.length;
        var isFromTo = l === 2 && !$84e77bd4943abbdb$var$is.obj(prop[0]);
        if (!isFromTo) // Duration divided by the number of tweens
        {
            if (!$84e77bd4943abbdb$var$is.fnc(tweenSettings.duration)) settings.duration = tweenSettings.duration / l;
        } else // Transform [from, to] values shorthand to a valid tween value
        prop = {
            value: prop
        };
    }
    var propArray = $84e77bd4943abbdb$var$is.arr(prop) ? prop : [
        prop
    ];
    return propArray.map(function(v, i) {
        var obj = $84e77bd4943abbdb$var$is.obj(v) && !$84e77bd4943abbdb$var$is.pth(v) ? v : {
            value: v
        };
        // Default delay value should only be applied to the first tween
        if ($84e77bd4943abbdb$var$is.und(obj.delay)) obj.delay = !i ? tweenSettings.delay : 0;
        // Default endDelay value should only be applied to the last tween
        if ($84e77bd4943abbdb$var$is.und(obj.endDelay)) obj.endDelay = i === propArray.length - 1 ? tweenSettings.endDelay : 0;
        return obj;
    }).map(function(k) {
        return $84e77bd4943abbdb$var$mergeObjects(k, settings);
    });
}
function $84e77bd4943abbdb$var$flattenKeyframes(keyframes) {
    var propertyNames = $84e77bd4943abbdb$var$filterArray($84e77bd4943abbdb$var$flattenArray(keyframes.map(function(key) {
        return Object.keys(key);
    })), function(p) {
        return $84e77bd4943abbdb$var$is.key(p);
    }).reduce(function(a, b) {
        if (a.indexOf(b) < 0) a.push(b);
        return a;
    }, []);
    var properties = {};
    var loop = function(i) {
        var propName = propertyNames[i];
        properties[propName] = keyframes.map(function(key) {
            var newKey = {};
            for(var p in key){
                if ($84e77bd4943abbdb$var$is.key(p)) {
                    if (p == propName) newKey.value = key[p];
                } else newKey[p] = key[p];
            }
            return newKey;
        });
    };
    for(var i = 0; i < propertyNames.length; i++)loop(i);
    return properties;
}
function $84e77bd4943abbdb$var$getProperties(tweenSettings, params) {
    var properties = [];
    var keyframes = params.keyframes;
    if (keyframes) params = $84e77bd4943abbdb$var$mergeObjects($84e77bd4943abbdb$var$flattenKeyframes(keyframes), params);
    for(var p in params)if ($84e77bd4943abbdb$var$is.key(p)) properties.push({
        name: p,
        tweens: $84e77bd4943abbdb$var$normalizePropertyTweens(params[p], tweenSettings)
    });
    return properties;
}
// Tweens
function $84e77bd4943abbdb$var$normalizeTweenValues(tween, animatable) {
    var t = {};
    for(var p in tween){
        var value = $84e77bd4943abbdb$var$getFunctionValue(tween[p], animatable);
        if ($84e77bd4943abbdb$var$is.arr(value)) {
            value = value.map(function(v) {
                return $84e77bd4943abbdb$var$getFunctionValue(v, animatable);
            });
            if (value.length === 1) value = value[0];
        }
        t[p] = value;
    }
    t.duration = parseFloat(t.duration);
    t.delay = parseFloat(t.delay);
    return t;
}
function $84e77bd4943abbdb$var$normalizeTweens(prop, animatable) {
    var previousTween;
    return prop.tweens.map(function(t) {
        var tween = $84e77bd4943abbdb$var$normalizeTweenValues(t, animatable);
        var tweenValue = tween.value;
        var to = $84e77bd4943abbdb$var$is.arr(tweenValue) ? tweenValue[1] : tweenValue;
        var toUnit = $84e77bd4943abbdb$var$getUnit(to);
        var originalValue = $84e77bd4943abbdb$var$getOriginalTargetValue(animatable.target, prop.name, toUnit, animatable);
        var previousValue = previousTween ? previousTween.to.original : originalValue;
        var from = $84e77bd4943abbdb$var$is.arr(tweenValue) ? tweenValue[0] : previousValue;
        var fromUnit = $84e77bd4943abbdb$var$getUnit(from) || $84e77bd4943abbdb$var$getUnit(originalValue);
        var unit = toUnit || fromUnit;
        if ($84e77bd4943abbdb$var$is.und(to)) to = previousValue;
        tween.from = $84e77bd4943abbdb$var$decomposeValue(from, unit);
        tween.to = $84e77bd4943abbdb$var$decomposeValue($84e77bd4943abbdb$var$getRelativeValue(to, from), unit);
        tween.start = previousTween ? previousTween.end : 0;
        tween.end = tween.start + tween.delay + tween.duration + tween.endDelay;
        tween.easing = $84e77bd4943abbdb$var$parseEasings(tween.easing, tween.duration);
        tween.isPath = $84e77bd4943abbdb$var$is.pth(tweenValue);
        tween.isPathTargetInsideSVG = tween.isPath && $84e77bd4943abbdb$var$is.svg(animatable.target);
        tween.isColor = $84e77bd4943abbdb$var$is.col(tween.from.original);
        if (tween.isColor) tween.round = 1;
        previousTween = tween;
        return tween;
    });
}
// Tween progress
var $84e77bd4943abbdb$var$setProgressValue = {
    css: function(t, p, v) {
        return t.style[p] = v;
    },
    attribute: function(t, p, v) {
        return t.setAttribute(p, v);
    },
    object: function(t, p, v) {
        return t[p] = v;
    },
    transform: function(t, p, v, transforms, manual) {
        transforms.list.set(p, v);
        if (p === transforms.last || manual) {
            var str = "";
            transforms.list.forEach(function(value, prop) {
                str += prop + "(" + value + ") ";
            });
            t.style.transform = str;
        }
    }
};
// Set Value helper
function $84e77bd4943abbdb$var$setTargetsValue(targets, properties) {
    var animatables = $84e77bd4943abbdb$var$getAnimatables(targets);
    animatables.forEach(function(animatable) {
        for(var property in properties){
            var value = $84e77bd4943abbdb$var$getFunctionValue(properties[property], animatable);
            var target = animatable.target;
            var valueUnit = $84e77bd4943abbdb$var$getUnit(value);
            var originalValue = $84e77bd4943abbdb$var$getOriginalTargetValue(target, property, valueUnit, animatable);
            var unit = valueUnit || $84e77bd4943abbdb$var$getUnit(originalValue);
            var to = $84e77bd4943abbdb$var$getRelativeValue($84e77bd4943abbdb$var$validateValue(value, unit), originalValue);
            var animType = $84e77bd4943abbdb$var$getAnimationType(target, property);
            $84e77bd4943abbdb$var$setProgressValue[animType](target, property, to, animatable.transforms, true);
        }
    });
}
// Animations
function $84e77bd4943abbdb$var$createAnimation(animatable, prop) {
    var animType = $84e77bd4943abbdb$var$getAnimationType(animatable.target, prop.name);
    if (animType) {
        var tweens = $84e77bd4943abbdb$var$normalizeTweens(prop, animatable);
        var lastTween = tweens[tweens.length - 1];
        return {
            type: animType,
            property: prop.name,
            animatable: animatable,
            tweens: tweens,
            duration: lastTween.end,
            delay: tweens[0].delay,
            endDelay: lastTween.endDelay
        };
    }
}
function $84e77bd4943abbdb$var$getAnimations(animatables, properties) {
    return $84e77bd4943abbdb$var$filterArray($84e77bd4943abbdb$var$flattenArray(animatables.map(function(animatable) {
        return properties.map(function(prop) {
            return $84e77bd4943abbdb$var$createAnimation(animatable, prop);
        });
    })), function(a) {
        return !$84e77bd4943abbdb$var$is.und(a);
    });
}
// Create Instance
function $84e77bd4943abbdb$var$getInstanceTimings(animations, tweenSettings) {
    var animLength = animations.length;
    var getTlOffset = function(anim) {
        return anim.timelineOffset ? anim.timelineOffset : 0;
    };
    var timings = {};
    timings.duration = animLength ? Math.max.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.duration;
    })) : tweenSettings.duration;
    timings.delay = animLength ? Math.min.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.delay;
    })) : tweenSettings.delay;
    timings.endDelay = animLength ? timings.duration - Math.max.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.duration - anim.endDelay;
    })) : tweenSettings.endDelay;
    return timings;
}
var $84e77bd4943abbdb$var$instanceID = 0;
function $84e77bd4943abbdb$var$createNewInstance(params) {
    var instanceSettings = $84e77bd4943abbdb$var$replaceObjectProps($84e77bd4943abbdb$var$defaultInstanceSettings, params);
    var tweenSettings = $84e77bd4943abbdb$var$replaceObjectProps($84e77bd4943abbdb$var$defaultTweenSettings, params);
    var properties = $84e77bd4943abbdb$var$getProperties(tweenSettings, params);
    var animatables = $84e77bd4943abbdb$var$getAnimatables(params.targets);
    var animations = $84e77bd4943abbdb$var$getAnimations(animatables, properties);
    var timings = $84e77bd4943abbdb$var$getInstanceTimings(animations, tweenSettings);
    var id = $84e77bd4943abbdb$var$instanceID;
    $84e77bd4943abbdb$var$instanceID++;
    return $84e77bd4943abbdb$var$mergeObjects(instanceSettings, {
        id: id,
        children: [],
        animatables: animatables,
        animations: animations,
        duration: timings.duration,
        delay: timings.delay,
        endDelay: timings.endDelay
    });
}
// Core
var $84e77bd4943abbdb$var$activeInstances = [];
var $84e77bd4943abbdb$var$engine = function() {
    var raf;
    function play() {
        if (!raf && (!$84e77bd4943abbdb$var$isDocumentHidden() || !$84e77bd4943abbdb$var$anime.suspendWhenDocumentHidden) && $84e77bd4943abbdb$var$activeInstances.length > 0) raf = requestAnimationFrame(step);
    }
    function step(t) {
        // memo on algorithm issue:
        // dangerous iteration over mutable `activeInstances`
        // (that collection may be updated from within callbacks of `tick`-ed animation instances)
        var activeInstancesLength = $84e77bd4943abbdb$var$activeInstances.length;
        var i = 0;
        while(i < activeInstancesLength){
            var activeInstance = $84e77bd4943abbdb$var$activeInstances[i];
            if (!activeInstance.paused) {
                activeInstance.tick(t);
                i++;
            } else {
                $84e77bd4943abbdb$var$activeInstances.splice(i, 1);
                activeInstancesLength--;
            }
        }
        raf = i > 0 ? requestAnimationFrame(step) : undefined;
    }
    function handleVisibilityChange() {
        if (!$84e77bd4943abbdb$var$anime.suspendWhenDocumentHidden) return;
        if ($84e77bd4943abbdb$var$isDocumentHidden()) // suspend ticks
        raf = cancelAnimationFrame(raf);
        else {
            // first adjust animations to consider the time that ticks were suspended
            $84e77bd4943abbdb$var$activeInstances.forEach(function(instance) {
                return instance._onDocumentVisibility();
            });
            $84e77bd4943abbdb$var$engine();
        }
    }
    if (typeof document !== "undefined") document.addEventListener("visibilitychange", handleVisibilityChange);
    return play;
}();
function $84e77bd4943abbdb$var$isDocumentHidden() {
    return !!document && document.hidden;
}
// Public Instance
function $84e77bd4943abbdb$var$anime(params) {
    if (params === void 0) params = {};
    var startTime = 0, lastTime = 0, now = 0;
    var children, childrenLength = 0;
    var resolve = null;
    function makePromise(instance) {
        var promise = window.Promise && new Promise(function(_resolve) {
            return resolve = _resolve;
        });
        instance.finished = promise;
        return promise;
    }
    var instance = $84e77bd4943abbdb$var$createNewInstance(params);
    var promise = makePromise(instance);
    function toggleInstanceDirection() {
        var direction = instance.direction;
        if (direction !== "alternate") instance.direction = direction !== "normal" ? "normal" : "reverse";
        instance.reversed = !instance.reversed;
        children.forEach(function(child) {
            return child.reversed = instance.reversed;
        });
    }
    function adjustTime(time) {
        return instance.reversed ? instance.duration - time : time;
    }
    function resetTime() {
        startTime = 0;
        lastTime = adjustTime(instance.currentTime) * (1 / $84e77bd4943abbdb$var$anime.speed);
    }
    function seekChild(time, child) {
        if (child) child.seek(time - child.timelineOffset);
    }
    function syncInstanceChildren(time) {
        if (!instance.reversePlayback) for(var i = 0; i < childrenLength; i++)seekChild(time, children[i]);
        else for(var i$1 = childrenLength; i$1--;)seekChild(time, children[i$1]);
    }
    function setAnimationsProgress(insTime) {
        var i = 0;
        var animations = instance.animations;
        var animationsLength = animations.length;
        while(i < animationsLength){
            var anim = animations[i];
            var animatable = anim.animatable;
            var tweens = anim.tweens;
            var tweenLength = tweens.length - 1;
            var tween = tweens[tweenLength];
            // Only check for keyframes if there is more than one tween
            if (tweenLength) tween = $84e77bd4943abbdb$var$filterArray(tweens, function(t) {
                return insTime < t.end;
            })[0] || tween;
            var elapsed = $84e77bd4943abbdb$var$minMax(insTime - tween.start - tween.delay, 0, tween.duration) / tween.duration;
            var eased = isNaN(elapsed) ? 1 : tween.easing(elapsed);
            var strings = tween.to.strings;
            var round = tween.round;
            var numbers = [];
            var toNumbersLength = tween.to.numbers.length;
            var progress = void 0;
            for(var n = 0; n < toNumbersLength; n++){
                var value = void 0;
                var toNumber = tween.to.numbers[n];
                var fromNumber = tween.from.numbers[n] || 0;
                if (!tween.isPath) value = fromNumber + eased * (toNumber - fromNumber);
                else value = $84e77bd4943abbdb$var$getPathProgress(tween.value, eased * toNumber, tween.isPathTargetInsideSVG);
                if (round) {
                    if (!(tween.isColor && n > 2)) value = Math.round(value * round) / round;
                }
                numbers.push(value);
            }
            // Manual Array.reduce for better performances
            var stringsLength = strings.length;
            if (!stringsLength) progress = numbers[0];
            else {
                progress = strings[0];
                for(var s = 0; s < stringsLength; s++){
                    var a = strings[s];
                    var b = strings[s + 1];
                    var n$1 = numbers[s];
                    if (!isNaN(n$1)) {
                        if (!b) progress += n$1 + " ";
                        else progress += n$1 + b;
                    }
                }
            }
            $84e77bd4943abbdb$var$setProgressValue[anim.type](animatable.target, anim.property, progress, animatable.transforms);
            anim.currentValue = progress;
            i++;
        }
    }
    function setCallback(cb) {
        if (instance[cb] && !instance.passThrough) instance[cb](instance);
    }
    function countIteration() {
        if (instance.remaining && instance.remaining !== true) instance.remaining--;
    }
    function setInstanceProgress(engineTime) {
        var insDuration = instance.duration;
        var insDelay = instance.delay;
        var insEndDelay = insDuration - instance.endDelay;
        var insTime = adjustTime(engineTime);
        instance.progress = $84e77bd4943abbdb$var$minMax(insTime / insDuration * 100, 0, 100);
        instance.reversePlayback = insTime < instance.currentTime;
        if (children) syncInstanceChildren(insTime);
        if (!instance.began && instance.currentTime > 0) {
            instance.began = true;
            setCallback("begin");
        }
        if (!instance.loopBegan && instance.currentTime > 0) {
            instance.loopBegan = true;
            setCallback("loopBegin");
        }
        if (insTime <= insDelay && instance.currentTime !== 0) setAnimationsProgress(0);
        if (insTime >= insEndDelay && instance.currentTime !== insDuration || !insDuration) setAnimationsProgress(insDuration);
        if (insTime > insDelay && insTime < insEndDelay) {
            if (!instance.changeBegan) {
                instance.changeBegan = true;
                instance.changeCompleted = false;
                setCallback("changeBegin");
            }
            setCallback("change");
            setAnimationsProgress(insTime);
        } else if (instance.changeBegan) {
            instance.changeCompleted = true;
            instance.changeBegan = false;
            setCallback("changeComplete");
        }
        instance.currentTime = $84e77bd4943abbdb$var$minMax(insTime, 0, insDuration);
        if (instance.began) setCallback("update");
        if (engineTime >= insDuration) {
            lastTime = 0;
            countIteration();
            if (!instance.remaining) {
                instance.paused = true;
                if (!instance.completed) {
                    instance.completed = true;
                    setCallback("loopComplete");
                    setCallback("complete");
                    if (!instance.passThrough && "Promise" in window) {
                        resolve();
                        promise = makePromise(instance);
                    }
                }
            } else {
                startTime = now;
                setCallback("loopComplete");
                instance.loopBegan = false;
                if (instance.direction === "alternate") toggleInstanceDirection();
            }
        }
    }
    instance.reset = function() {
        var direction = instance.direction;
        instance.passThrough = false;
        instance.currentTime = 0;
        instance.progress = 0;
        instance.paused = true;
        instance.began = false;
        instance.loopBegan = false;
        instance.changeBegan = false;
        instance.completed = false;
        instance.changeCompleted = false;
        instance.reversePlayback = false;
        instance.reversed = direction === "reverse";
        instance.remaining = instance.loop;
        children = instance.children;
        childrenLength = children.length;
        for(var i = childrenLength; i--;)instance.children[i].reset();
        if (instance.reversed && instance.loop !== true || direction === "alternate" && instance.loop === 1) instance.remaining++;
        setAnimationsProgress(instance.reversed ? instance.duration : 0);
    };
    // internal method (for engine) to adjust animation timings before restoring engine ticks (rAF)
    instance._onDocumentVisibility = resetTime;
    // Set Value helper
    instance.set = function(targets, properties) {
        $84e77bd4943abbdb$var$setTargetsValue(targets, properties);
        return instance;
    };
    instance.tick = function(t) {
        now = t;
        if (!startTime) startTime = now;
        setInstanceProgress((now + (lastTime - startTime)) * $84e77bd4943abbdb$var$anime.speed);
    };
    instance.seek = function(time) {
        setInstanceProgress(adjustTime(time));
    };
    instance.pause = function() {
        instance.paused = true;
        resetTime();
    };
    instance.play = function() {
        if (!instance.paused) return;
        if (instance.completed) instance.reset();
        instance.paused = false;
        $84e77bd4943abbdb$var$activeInstances.push(instance);
        resetTime();
        $84e77bd4943abbdb$var$engine();
    };
    instance.reverse = function() {
        toggleInstanceDirection();
        instance.completed = instance.reversed ? false : true;
        resetTime();
    };
    instance.restart = function() {
        instance.reset();
        instance.play();
    };
    instance.remove = function(targets) {
        var targetsArray = $84e77bd4943abbdb$var$parseTargets(targets);
        $84e77bd4943abbdb$var$removeTargetsFromInstance(targetsArray, instance);
    };
    instance.reset();
    if (instance.autoplay) instance.play();
    return instance;
}
// Remove targets from animation
function $84e77bd4943abbdb$var$removeTargetsFromAnimations(targetsArray, animations) {
    for(var a = animations.length; a--;)if ($84e77bd4943abbdb$var$arrayContains(targetsArray, animations[a].animatable.target)) animations.splice(a, 1);
}
function $84e77bd4943abbdb$var$removeTargetsFromInstance(targetsArray, instance) {
    var animations = instance.animations;
    var children = instance.children;
    $84e77bd4943abbdb$var$removeTargetsFromAnimations(targetsArray, animations);
    for(var c = children.length; c--;){
        var child = children[c];
        var childAnimations = child.animations;
        $84e77bd4943abbdb$var$removeTargetsFromAnimations(targetsArray, childAnimations);
        if (!childAnimations.length && !child.children.length) children.splice(c, 1);
    }
    if (!animations.length && !children.length) instance.pause();
}
function $84e77bd4943abbdb$var$removeTargetsFromActiveInstances(targets) {
    var targetsArray = $84e77bd4943abbdb$var$parseTargets(targets);
    for(var i = $84e77bd4943abbdb$var$activeInstances.length; i--;){
        var instance = $84e77bd4943abbdb$var$activeInstances[i];
        $84e77bd4943abbdb$var$removeTargetsFromInstance(targetsArray, instance);
    }
}
// Stagger helpers
function $84e77bd4943abbdb$var$stagger(val, params) {
    if (params === void 0) params = {};
    var direction = params.direction || "normal";
    var easing = params.easing ? $84e77bd4943abbdb$var$parseEasings(params.easing) : null;
    var grid = params.grid;
    var axis = params.axis;
    var fromIndex = params.from || 0;
    var fromFirst = fromIndex === "first";
    var fromCenter = fromIndex === "center";
    var fromLast = fromIndex === "last";
    var isRange = $84e77bd4943abbdb$var$is.arr(val);
    var val1 = isRange ? parseFloat(val[0]) : parseFloat(val);
    var val2 = isRange ? parseFloat(val[1]) : 0;
    var unit = $84e77bd4943abbdb$var$getUnit(isRange ? val[1] : val) || 0;
    var start = params.start || 0 + (isRange ? val1 : 0);
    var values = [];
    var maxValue = 0;
    return function(el, i, t) {
        if (fromFirst) fromIndex = 0;
        if (fromCenter) fromIndex = (t - 1) / 2;
        if (fromLast) fromIndex = t - 1;
        if (!values.length) {
            for(var index = 0; index < t; index++){
                if (!grid) values.push(Math.abs(fromIndex - index));
                else {
                    var fromX = !fromCenter ? fromIndex % grid[0] : (grid[0] - 1) / 2;
                    var fromY = !fromCenter ? Math.floor(fromIndex / grid[0]) : (grid[1] - 1) / 2;
                    var toX = index % grid[0];
                    var toY = Math.floor(index / grid[0]);
                    var distanceX = fromX - toX;
                    var distanceY = fromY - toY;
                    var value = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
                    if (axis === "x") value = -distanceX;
                    if (axis === "y") value = -distanceY;
                    values.push(value);
                }
                maxValue = Math.max.apply(Math, values);
            }
            if (easing) values = values.map(function(val) {
                return easing(val / maxValue) * maxValue;
            });
            if (direction === "reverse") values = values.map(function(val) {
                return axis ? val < 0 ? val * -1 : -val : Math.abs(maxValue - val);
            });
        }
        var spacing = isRange ? (val2 - val1) / maxValue : val1;
        return start + spacing * (Math.round(values[i] * 100) / 100) + unit;
    };
}
// Timeline
function $84e77bd4943abbdb$var$timeline(params) {
    if (params === void 0) params = {};
    var tl = $84e77bd4943abbdb$var$anime(params);
    tl.duration = 0;
    tl.add = function(instanceParams, timelineOffset) {
        var tlIndex = $84e77bd4943abbdb$var$activeInstances.indexOf(tl);
        var children = tl.children;
        if (tlIndex > -1) $84e77bd4943abbdb$var$activeInstances.splice(tlIndex, 1);
        function passThrough(ins) {
            ins.passThrough = true;
        }
        for(var i = 0; i < children.length; i++)passThrough(children[i]);
        var insParams = $84e77bd4943abbdb$var$mergeObjects(instanceParams, $84e77bd4943abbdb$var$replaceObjectProps($84e77bd4943abbdb$var$defaultTweenSettings, params));
        insParams.targets = insParams.targets || params.targets;
        var tlDuration = tl.duration;
        insParams.autoplay = false;
        insParams.direction = tl.direction;
        insParams.timelineOffset = $84e77bd4943abbdb$var$is.und(timelineOffset) ? tlDuration : $84e77bd4943abbdb$var$getRelativeValue(timelineOffset, tlDuration);
        passThrough(tl);
        tl.seek(insParams.timelineOffset);
        var ins = $84e77bd4943abbdb$var$anime(insParams);
        passThrough(ins);
        children.push(ins);
        var timings = $84e77bd4943abbdb$var$getInstanceTimings(children, params);
        tl.delay = timings.delay;
        tl.endDelay = timings.endDelay;
        tl.duration = timings.duration;
        tl.seek(0);
        tl.reset();
        if (tl.autoplay) tl.play();
        return tl;
    };
    return tl;
}
$84e77bd4943abbdb$var$anime.version = "3.2.1";
$84e77bd4943abbdb$var$anime.speed = 1;
// TODO:#review: naming, documentation
$84e77bd4943abbdb$var$anime.suspendWhenDocumentHidden = true;
$84e77bd4943abbdb$var$anime.running = $84e77bd4943abbdb$var$activeInstances;
$84e77bd4943abbdb$var$anime.remove = $84e77bd4943abbdb$var$removeTargetsFromActiveInstances;
$84e77bd4943abbdb$var$anime.get = $84e77bd4943abbdb$var$getOriginalTargetValue;
$84e77bd4943abbdb$var$anime.set = $84e77bd4943abbdb$var$setTargetsValue;
$84e77bd4943abbdb$var$anime.convertPx = $84e77bd4943abbdb$var$convertPxToUnit;
$84e77bd4943abbdb$var$anime.path = $84e77bd4943abbdb$var$getPath;
$84e77bd4943abbdb$var$anime.setDashoffset = $84e77bd4943abbdb$var$setDashoffset;
$84e77bd4943abbdb$var$anime.stagger = $84e77bd4943abbdb$var$stagger;
$84e77bd4943abbdb$var$anime.timeline = $84e77bd4943abbdb$var$timeline;
$84e77bd4943abbdb$var$anime.easing = $84e77bd4943abbdb$var$parseEasings;
$84e77bd4943abbdb$var$anime.penner = $84e77bd4943abbdb$var$penner;
$84e77bd4943abbdb$var$anime.random = function(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
var $84e77bd4943abbdb$export$2e2bcd8739ae039 = $84e77bd4943abbdb$var$anime;


function $6b6d359f8540f093$export$1ba12a2986af3144(parent, last = false) {
    const focusable = parent.querySelectorAll("a, button, input, textarea, select, details");
    if (focusable.length === 0) return null;
    if (last === true) return focusable[focusable.length - 1];
    return focusable[0];
}
function $6b6d359f8540f093$export$1f34108aa9eb96ab(ms) {
    return "matchMedia" in window && matchMedia("(prefers-reduced-motion: reduce)").matches ? 1 : ms * 1.1;
}
function $6b6d359f8540f093$export$2ec5ed714caf00d0() {
    let callbacksWereInvoked = false;
    let invokationArgument;
    const callbacks = [];
    return {
        add (callback) {
            callbacks.push(callback);
            if (callbacksWereInvoked) callback(invokationArgument);
        },
        invoke (argument) {
            callbacks.forEach((callback)=>callback(argument));
            invokationArgument = argument;
            callbacksWereInvoked = true;
        }
    };
}
/**
 * Trap focus
 */ const $6b6d359f8540f093$var$handleKeyUp = (el)=>(ev)=>{
        if (ev.key === "Tab" && ev.target instanceof HTMLElement && !el.contains(ev.target)) {
            if (ev.shiftKey) $6b6d359f8540f093$export$1ba12a2986af3144(el, true)?.focus();
            else $6b6d359f8540f093$export$1ba12a2986af3144(el)?.focus();
        }
    };
let $6b6d359f8540f093$var$trapMap = [];
function $6b6d359f8540f093$export$bec45a54c2e66c22(el) {
    let trap = $6b6d359f8540f093$var$trapMap.find(({ el: element })=>element === el);
    if (!trap) {
        trap = {
            el: el,
            handleKeyUp: $6b6d359f8540f093$var$handleKeyUp(el)
        };
        $6b6d359f8540f093$var$trapMap.push(trap);
    }
    document.addEventListener("keyup", trap.handleKeyUp);
}
function $6b6d359f8540f093$export$6e151c0ad71c021a(el) {
    let trap = $6b6d359f8540f093$var$trapMap.find(({ el: element })=>element === el);
    if (trap) document.removeEventListener("keyup", trap.handleKeyUp);
}


const $a2faba4c18df903e$var$headers = document.querySelectorAll("[data-header]");
$a2faba4c18df903e$var$headers.forEach((header)=>{
    const button = header.querySelector("[data-button]");
    const menu = header.querySelector("[data-menu]");
    const logoWhite = header.querySelector("[data-logo-white]");
    if (!button || !menu) return;
    const openLabel = button.getAttribute("aria-label");
    const closeLabel = button.getAttribute("data-button-close-label");
    const items = menu.querySelectorAll("li");
    const logos = menu.querySelector("[data-logos]");
    const cover = header.querySelector("[data-header-cover]");
    let neverOpened = true;
    let menuOpen = false;
    const menuDisplayMode = "flex"; // window.getComputedStyle(menu).display;
    /**
	 * Animations
	 */ const openSymbol = button.querySelector("[data-open-symbol]");
    const closeSymbol = button.querySelector("[data-close-symbol]");
    const menuButtonAnimation = (0, $84e77bd4943abbdb$export$2e2bcd8739ae039).timeline({
        direction: "alternate",
        autoplay: false,
        loop: false,
        duration: (0, $6b6d359f8540f093$export$1f34108aa9eb96ab)(450),
        easing: "cubicBezier(0.32, -0.24, 0, 1.4)"
    });
    menuButtonAnimation.add({
        targets: openSymbol,
        rotate: [
            0,
            -45
        ],
        scaleY: [
            1,
            0.1
        ],
        scaleX: [
            1,
            0.8
        ],
        opacity: [
            1,
            0
        ]
    }, 0);
    menuButtonAnimation.add({
        targets: closeSymbol,
        rotate: [
            45,
            0
        ],
        opacity: [
            0,
            1
        ],
        scale: [
            0.8,
            1
        ]
    }, 0);
    const animation = (0, $84e77bd4943abbdb$export$2e2bcd8739ae039).timeline({
        direction: "alternate",
        autoplay: false,
        loop: false,
        begin () {},
        complete () {
            if (animation.progress === 0) {
                menu.style.display = "none";
                if (cover) cover.style.display = "none";
            }
        }
    });
    // The menu
    animation.add({
        targets: menu,
        translateX: [
            "-100%",
            "0%"
        ],
        // opacity: [0, 1],
        easing: "cubicBezier(.16,.13,.12,1)",
        duration: (0, $6b6d359f8540f093$export$1f34108aa9eb96ab)(400)
    }, 0);
    // Background cover
    animation.add({
        targets: cover,
        opacity: [
            0,
            0.4
        ],
        easing: "linear",
        duration: (0, $6b6d359f8540f093$export$1f34108aa9eb96ab)(400)
    }, 0);
    // White mask of logo
    animation.add({
        targets: logoWhite,
        scaleX: [
            0,
            1
        ],
        easing: "linear",
        duration: (0, $6b6d359f8540f093$export$1f34108aa9eb96ab)(60)
    }, (0, $6b6d359f8540f093$export$1f34108aa9eb96ab)(10));
    // Each menu item
    animation.add({
        targets: items,
        opacity: [
            0,
            1
        ],
        translateX: [
            "-2.5rem",
            "0rem"
        ],
        easing: "cubicBezier(0.1, 1.54, 0.62, 0.97)",
        duration: (0, $6b6d359f8540f093$export$1f34108aa9eb96ab)(300),
        delay: (_, i)=>(0, $6b6d359f8540f093$export$1f34108aa9eb96ab)(i * 50)
    }, (0, $6b6d359f8540f093$export$1f34108aa9eb96ab)(50));
    // Newsletter box
    animation.add({
        targets: logos,
        opacity: [
            0,
            1
        ],
        translateY: [
            "2rem",
            "0rem"
        ],
        easing: "cubicBezier(0.1, 1.54, 0.62, 0.97)",
        duration: (0, $6b6d359f8540f093$export$1f34108aa9eb96ab)(300)
    }, (0, $6b6d359f8540f093$export$1f34108aa9eb96ab)(items.length * 50));
    /**
	 * Open / close functions
	 */ const openMenu = ()=>{
        menuOpen = true;
        if (neverOpened) {
            menu.style.display = menuDisplayMode;
            menu.style.transform = "translateX(-100%)";
            neverOpened = false;
        }
        if (animation.progress === 0) {
            menu.style.display = menuDisplayMode;
            if (cover) cover.style.display = "block";
        }
        if (closeLabel) button.setAttribute("aria-label", closeLabel);
        (0, $f731e8acd6e365c2$export$24fdf68abf432c44)(menu);
        if (menuButtonAnimation.reversed) menuButtonAnimation.reverse();
        menuButtonAnimation.play();
        if (animation.reversed) animation.reverse();
        animation.play();
    };
    const closeMenu = ()=>{
        menuOpen = false;
        if (openLabel) button.setAttribute("aria-label", openLabel);
        (0, $f731e8acd6e365c2$export$e5d0524c3725571e)(menu);
        if (!menuButtonAnimation.reversed) menuButtonAnimation.reverse();
        menuButtonAnimation.play();
        if (!animation.reversed) animation.reverse();
        animation.play();
    };
    /**
	 * Event handlers
	 */ // Open when clicking button
    button.addEventListener("click", ()=>{
        if (!menuOpen) {
            openMenu();
            (0, $6b6d359f8540f093$export$1ba12a2986af3144)(menu)?.focus();
        } else closeMenu();
    });
    // Close when clicking outside element
    document.addEventListener("click", (ev)=>{
        if (menuOpen && ev.target instanceof HTMLElement && (!header.contains(ev.target) || ev.target === cover)) closeMenu();
    });
    // Close when pressing Escape
    document.addEventListener("keyup", (ev)=>{
        if (ev.key === "Escape" && menuOpen) {
            button.focus();
            closeMenu();
        }
    });
    // Trap focus
    document.addEventListener("keyup", (ev)=>{
        if (menuOpen && ev.key === "Tab" && ev.target instanceof HTMLElement && !header.contains(ev.target)) {
            if (ev.shiftKey) (0, $6b6d359f8540f093$export$1ba12a2986af3144)(header, true)?.focus();
            else (0, $6b6d359f8540f093$export$1ba12a2986af3144)(header)?.focus();
        }
    });
});


var $acb7ced0d5fe5ad2$exports = {};
(function(global, factory) {
    $acb7ced0d5fe5ad2$exports = factory();
})($acb7ced0d5fe5ad2$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});






/**
 * Callback stuff
 */ const $34a17b4a22b3293b$var$callbacks = (0, $6b6d359f8540f093$export$2ec5ed714caf00d0)();
const $34a17b4a22b3293b$var$immediateCallbacks = (0, $6b6d359f8540f093$export$2ec5ed714caf00d0)();
const $34a17b4a22b3293b$export$e2ac0467fba72bdc = $34a17b4a22b3293b$var$callbacks.add;
const $34a17b4a22b3293b$export$b867d73f2e833433 = $34a17b4a22b3293b$var$immediateCallbacks.add;
/**
 * Compare dates
 */ const $34a17b4a22b3293b$var$checkAgeElements = (limit, year, month, day)=>{
    return $34a17b4a22b3293b$var$checkAge(limit, year?.value, month?.value, day?.value);
};
const $34a17b4a22b3293b$var$checkAge = (limit, year, month, day)=>{
    // Year needs to be provided. Month and day are accepted if they are undefined
    // (fields not available on the page) but rejected if they are '' (fields available
    // without a set value).
    if (!year || month === "" || day === "") return false;
    const yearN = Number(year);
    const monthN = Number(month || 0);
    const dayN = Number(day || 1);
    // Default to January 1
    if (isNaN(yearN) || isNaN(monthN) || isNaN(dayN)) return false;
    const earliest = new Date();
    earliest.setFullYear(earliest.getFullYear() - limit);
    const provided = new Date(yearN, monthN - 1, dayN);
    return provided.getTime() < earliest.getTime();
};
window.addEventListener("DOMContentLoaded", ()=>{
    const el = document.querySelector("[data-age-check]");
    const content = el?.querySelector(".age-check__content");
    const form = el?.querySelector("[data-age-check-form]");
    const age_check = (0, (/*@__PURE__*/$parcel$interopDefault($acb7ced0d5fe5ad2$exports))).get("checked_age");
    if (!el || !form || age_check == "yes") {
        $34a17b4a22b3293b$var$immediateCallbacks.invoke(age_check || "");
        $34a17b4a22b3293b$var$callbacks.invoke(age_check || "");
        el?.parentElement?.removeChild(el);
        return;
    }
    /**
	 * Set up the age check
	 */ (0, $f731e8acd6e365c2$export$24fdf68abf432c44)(el);
    (0, $6b6d359f8540f093$export$bec45a54c2e66c22)(el);
    let ageLimit = Number(el.getAttribute("data-age-check-limit"));
    if (isNaN(ageLimit)) ageLimit = 20;
    const year = form.querySelector("#year");
    const month = form.querySelector("#month");
    const day = form.querySelector("#day");
    const remember = form.querySelector("#remember");
    const submit = form.querySelector('input[type="submit"]');
    if (submit) submit.disabled = !$34a17b4a22b3293b$var$checkAgeElements(ageLimit, year, month, day);
    form.addEventListener("change", ()=>{
        const validAge = $34a17b4a22b3293b$var$checkAgeElements(ageLimit, year, month, day);
        if (submit) submit.disabled = !validAge;
    });
    form.addEventListener("submit", (ev)=>{
        ev.preventDefault();
        const validAge = $34a17b4a22b3293b$var$checkAgeElements(ageLimit, year, month, day);
        if (validAge) {
            const attrs = {
                path: "/"
            };
            if (remember?.checked) attrs.expires = 30;
            (0, (/*@__PURE__*/$parcel$interopDefault($acb7ced0d5fe5ad2$exports))).set("checked_age", "yes", attrs);
            $34a17b4a22b3293b$var$immediateCallbacks.invoke("yes");
            const timeline = (0, $84e77bd4943abbdb$export$2e2bcd8739ae039).timeline({
                easing: "cubicBezier(.6,.02,.92,.73)",
                complete () {
                    (0, $6b6d359f8540f093$export$6e151c0ad71c021a)(el);
                    (0, $f731e8acd6e365c2$export$e5d0524c3725571e)(el);
                    el.parentNode?.removeChild(el);
                }
            });
            timeline.add({
                targets: content,
                opacity: 0,
                duration: (0, $6b6d359f8540f093$export$1f34108aa9eb96ab)(400),
                scale: 0.85
            }, 0);
            timeline.add({
                targets: el,
                opacity: 0,
                duration: (0, $6b6d359f8540f093$export$1f34108aa9eb96ab)(400)
            }, 250);
            window.setTimeout(()=>{
                $34a17b4a22b3293b$var$callbacks.invoke("yes");
            }, 500);
        }
    });
});


const $3ba81695811fb6d4$var$cookieInfoEls = document.querySelectorAll("[data-cookie-info]");
$3ba81695811fb6d4$var$cookieInfoEls.forEach((el)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($acb7ced0d5fe5ad2$exports))).get("accepted_cookies")) el.parentElement?.removeChild(el);
    el.style.display = "none";
    (0, $34a17b4a22b3293b$export$e2ac0467fba72bdc)(()=>{
        el.style.display = "block";
        el.classList.add("cookie-info--in");
        el.addEventListener("animationend", ()=>{
            el.classList.remove("cookie-info--in");
        });
    });
    const button = el.querySelector("[data-accept-button]");
    button?.addEventListener("click", ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($acb7ced0d5fe5ad2$exports))).set("accepted_cookies", "yes");
        el.addEventListener("transformend", ()=>{
            el.parentElement?.removeChild(el);
        });
        el.classList.add("cookie-info--out");
        console.log("click!");
    });
});
var $3ba81695811fb6d4$export$2e2bcd8739ae039 = $3ba81695811fb6d4$var$cookieInfoEls;








const $b97b73813f3138fd$var$measureHeight = (el)=>{
    const cachedStyles = el.getAttribute("style");
    el.setAttribute("style", "");
    const height = el.offsetHeight;
    const { marginTop: marginTop, marginBottom: marginBottom, paddingTop: paddingTop, paddingBottom: paddingBottom } = window.getComputedStyle(el);
    if (cachedStyles) el.setAttribute("style", cachedStyles);
    return {
        height: height,
        marginTop: marginTop,
        marginBottom: marginBottom,
        paddingTop: paddingTop,
        paddingBottom: paddingBottom
    };
};
const $b97b73813f3138fd$var$utilMakeHeightSetting = (opts)=>({
        delay: 0,
        easing: "cubicBezier(.05,1,.2,1)",
        ...opts
    });
/**
 * Show and hide by sliding up and down
 */ const $b97b73813f3138fd$var$slideHeightDuration = 600;
const $b97b73813f3138fd$var$slideOpacityDuration = 700;
const $b97b73813f3138fd$var$animationOverlap = 100;
function $b97b73813f3138fd$export$63abcd245140591c(el, callback = ()=>{}) {
    const { height: height } = $b97b73813f3138fd$var$measureHeight(el);
    const heightSetting = $b97b73813f3138fd$var$utilMakeHeightSetting({
        value: 0,
        delay: $b97b73813f3138fd$var$slideOpacityDuration - $b97b73813f3138fd$var$animationOverlap,
        duration: $b97b73813f3138fd$var$slideHeightDuration
    });
    el.style.minHeight = "0px";
    const children = el.querySelectorAll("*");
    (0, $84e77bd4943abbdb$export$2e2bcd8739ae039)({
        targets: el,
        height: {
            ...heightSetting,
            value: [
                height,
                0
            ]
        },
        marginTop: heightSetting,
        marginBottom: heightSetting,
        paddingTop: heightSetting,
        paddingBottom: heightSetting,
        complete: ()=>{
            el.style.display = "none";
            callback();
        }
    });
    (0, $84e77bd4943abbdb$export$2e2bcd8739ae039)({
        targets: children,
        opacity: {
            value: 0,
            delay: 0,
            duration: $b97b73813f3138fd$var$slideOpacityDuration,
            easing: "linear"
        }
    });
}


/**
 * Callback stuff
 */ const $759ac3c83ca07dcc$var$callbacks = (0, $6b6d359f8540f093$export$2ec5ed714caf00d0)();
const $759ac3c83ca07dcc$var$immediateCallbacks = (0, $6b6d359f8540f093$export$2ec5ed714caf00d0)();
const $759ac3c83ca07dcc$export$7c9f35d3f3b6e3f6 = $759ac3c83ca07dcc$var$callbacks.add;
const $759ac3c83ca07dcc$export$fbe43714b2ca7ecb = $759ac3c83ca07dcc$var$immediateCallbacks.add;
window.addEventListener("DOMContentLoaded", ()=>{
    const el = document.querySelector("[data-alcohol-preference]");
    const content = el?.querySelector(".age-check__content");
    const preference = (0, (/*@__PURE__*/$parcel$interopDefault($acb7ced0d5fe5ad2$exports))).get("alcohol_preference");
    if (!el || typeof preference !== "undefined") {
        $759ac3c83ca07dcc$var$immediateCallbacks.invoke({
            value: preference || "",
            willNavigate: false
        });
        $759ac3c83ca07dcc$var$callbacks.invoke({
            value: preference || "",
            willNavigate: false
        });
        el?.parentElement?.removeChild(el);
    }
    /**
	 * Set up the age check
	 */ if (el) {
        (0, $f731e8acd6e365c2$export$24fdf68abf432c44)(el);
        (0, $6b6d359f8540f093$export$bec45a54c2e66c22)(el);
    }
    const setPreference = (value, url, close)=>{
        const attrs = {
            path: "/",
            expires: 30
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($acb7ced0d5fe5ad2$exports))).set("alcohol_preference", value, attrs);
        $759ac3c83ca07dcc$var$immediateCallbacks.invoke({
            value: value,
            willNavigate: !!url
        });
        const timeline = (0, $84e77bd4943abbdb$export$2e2bcd8739ae039).timeline({
            easing: "cubicBezier(.6,.02,.92,.73)",
            complete () {
                if (el) {
                    (0, $6b6d359f8540f093$export$6e151c0ad71c021a)(el);
                    (0, $f731e8acd6e365c2$export$e5d0524c3725571e)(el);
                    el.parentNode?.removeChild(el);
                }
            }
        });
        timeline.add({
            targets: content,
            opacity: 0,
            duration: (0, $6b6d359f8540f093$export$1f34108aa9eb96ab)(400),
            scale: 0.85
        }, 0);
        timeline.add({
            targets: el,
            opacity: 0,
            duration: (0, $6b6d359f8540f093$export$1f34108aa9eb96ab)(400)
        }, 250);
        window.setTimeout(()=>{
            $759ac3c83ca07dcc$var$callbacks.invoke({
                value: value,
                willNavigate: !!url
            });
        }, 500);
        if (url) setTimeout(()=>{
            window.location.href = url;
        }, (0, $6b6d359f8540f093$export$1f34108aa9eb96ab)(400));
        else if (close) {
            const inPageElement = document.querySelector("[data-alcohol-preference-in-page]");
            if (inPageElement) (0, $b97b73813f3138fd$export$63abcd245140591c)(inPageElement);
        }
    };
    const actions = document.querySelectorAll("[data-alcohol-preference-set]");
    actions.forEach((action)=>{
        action.addEventListener("click", ()=>{
            const preference = action.getAttribute("data-alcohol-preference-set");
            const url = action.getAttribute("data-alcohol-preference-url");
            const closeAttr = action.getAttribute("data-alcohol-preference-close");
            const close = closeAttr !== null && closeAttr !== "false";
            if (!preference) return;
            setPreference(preference, url, close);
        });
    });
});


(0, $759ac3c83ca07dcc$export$fbe43714b2ca7ecb)(({ willNavigate: willNavigate })=>{
    if (willNavigate) {
        const ageCheckElements = document.querySelectorAll("[data-age-check] > *");
        ageCheckElements.forEach((element)=>element.style.opacity = "0");
    }
});
document.querySelectorAll("[data-go-back]").forEach((link)=>{
    link.addEventListener("click", (ev)=>{
        ev.preventDefault();
        history.back();
    });
});
const $c5c3293c4c351a67$var$isiOSSafari = ()=>{
    // https://stackoverflow.com/questions/3007480/determine-if-user-navigated-from-mobile-safari/29696509#29696509
    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
    return iOSSafari;
};
if ($c5c3293c4c351a67$var$isiOSSafari()) {
    const setHeaderHeight = ()=>{
        if (window.innerWidth > window.innerHeight) return;
        document.documentElement.style.setProperty("--full-height", `${window.innerHeight}px`);
    };
    setHeaderHeight();
}
/**
 * Animate cover sections
 */ document.addEventListener("DOMContentLoaded", ()=>{
    const els = document.querySelectorAll("[data-class-when-visible]");
    els.forEach((el)=>{
        const className = el.getAttribute("data-class-when-visible");
        if (!className) return;
        (0, $34a17b4a22b3293b$export$e2ac0467fba72bdc)(()=>{
            const observer = new IntersectionObserver((entries)=>{
                if (entries.some((entry)=>entry.isIntersecting)) {
                    observer.unobserve(el);
                    el.classList.add(className);
                }
            }, {
                threshold: 0.5,
                rootMargin: "0px"
            });
            observer.observe(el);
        });
    });
});
/**
 * Animate gallery collage blocks
 */ document.addEventListener("DOMContentLoaded", ()=>{
    const els = document.querySelectorAll(".wp-block-gallery.is-style-collage");
    els.forEach((el)=>{
        el.classList.add("animated");
        (0, $34a17b4a22b3293b$export$e2ac0467fba72bdc)(()=>{
            const observer = new IntersectionObserver((entries)=>{
                if (entries.some((entry)=>entry.isIntersecting)) {
                    observer.unobserve(el);
                    el.classList.add("animated--in");
                }
            }, {
                threshold: 0.5,
                rootMargin: "0px"
            });
            observer.observe(el);
        });
    });
});



})();
//# sourceMappingURL=scripts.js.map
